import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../Utils/AppContext";
import styled from "styled-components";
import { createCompany, updateCompany, getCompany } from "../Utils/Company";

const FormContainer = styled.div`
  margin-top: 30px;

  form {
    label {
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
    }
    p.error-message {
      margin-bottom: 12px;
      color: #d94a38;
      font-size: 14px;
    }
  }
`;

const Input = styled.input`
  border: ${props => (!props.fieldValid ? "solid 1px #d94a38" : "solid 1px #dbdee5")};
  padding: 10px;
  border-radius: 3px;
  font-size: 14px;
  margin-top: 4px;
`;

const CompanyForm = ({ companyId, formComplete }) => {
  const context = useContext(AppContext);

  // Set form mode
  const [formMode, setFormMode] = useState("create");
  const [validateForm, setValidateForm] = useState(false);
  const [formValid, setFormValid] = useState(true);

  const [name, setName] = useState("");

  useEffect(() => {
    if (companyId) {
      setFormMode("edit");

      getCompany(companyId).then(companyInfo => {
        setName(companyInfo.name);
      });
    }
  }, []);

  return (
    <form>
      <label htmlFor="companyName">
        Company Name:
        <br />
        <Input
          fieldValid={validateForm ? name : true}
          type="text"
          name="companyName"
          id="companyName"
          onChange={event => setName(event.target.value)}
          value={name}
        />
      </label>

      {!formValid && <p className="error-message">Please fill out all required fields.</p>}

      <br />

      <button
        type="button"
        onClick={() => {
          if (!name) {
            setValidateForm(true);
            setFormValid(false);
          } else {
            if (formMode === "create") {
              createCompany(name, context.state.user.uid).then(response => {
                if (formComplete) {
                  formComplete();
                }
              });
            } else {
              updateCompany(companyId, name).then(response => {
                if (formComplete) {
                  formComplete();
                }
              });
            }
          }
        }}
      >
        {formMode === "create" ? "Create Company" : "Update Company"}
      </button>
    </form>
  );
};

export default CompanyForm;
